const reIsPlainProp = /^\w*$/
export default reIsPlainProp 
